"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class PasswordRules extends _react.default.Component {
  render() {
    const {
      rules
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("ul", {
      className: 'password-strength-list'
    }, rules.hasNumber && /*#__PURE__*/_react.default.createElement("li", {
      className: this.props.hasNumber
    }, "At least one number (0-9)"), rules.hasLetter && /*#__PURE__*/_react.default.createElement("li", {
      className: this.props.hasLetter
    }, "At least one lowercase letter (a-z)"), rules.hasUppercase && /*#__PURE__*/_react.default.createElement("li", {
      className: this.props.hasUppercase
    }, "At least one uppercase letter (A-Z)"), /*#__PURE__*/_react.default.createElement("li", {
      className: this.props.isValidLength
    }, "At least ", rules.minLength, " characters"));
  }
}
exports.default = PasswordRules;
module.exports = exports.default;